import { PerksBanner } from "@/modules/plan-selection/components/perks-banner";
import type { AppContext, PaymentOption } from "@/types";

interface SinglePagePerksBannerProps {
  ctx: AppContext;
  option: PaymentOption;
  disabled?: boolean;
}

/** Perks / cashback / Farah banner for single-page checkout — sits above Pay in the sticky footer. */
export function SinglePagePerksBanner({
  ctx,
  option,
  disabled = false,
}: SinglePagePerksBannerProps) {
  if (option.tenure === 0) {
    return null;
  }

  return (
    <PerksBanner
      ctx={ctx}
      layout="above-pay"
      cashbackAmount={option.cashback?.actualAmount?.amount ?? 0}
      cashbackEligible={
        (option.cashback as { eligibleForCashback?: boolean } | undefined)
          ?.eligibleForCashback === true
      }
      appliedRewards={option.appliedRewards ?? null}
      waivedOffReason={option.waivedOffReason}
      waivedOffFeeAmount={option.waivedOffFee?.amount ?? 0}
      processingFeeAmount={option.processingFeeAmount?.amount ?? 0}
      isFeeWaivedOff={option.isFeeWaivedOff ?? false}
      disabled={disabled}
    />
  );
}
